"use strict";Object.defineProperty(exports,"__esModule",{value:!0});const t=require("../../../node_modules/graphql-tag/lib/index.js").gql`
    query byPostalCode($postalCode: String!) {
        LocationData {
            byPostalCode(postalCode: $postalCode) {
                postalCode
                city
                state
                latitude
                longitude
                cityStateFormatted
            }
        }
    }
`;exports.byPostalCode=t;
//# sourceMappingURL=queries.js.map
